import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import {
  GetSpecialistDetailResponse,
  getSpecialistDetails
} from '@/modules/accredited-establishments/api'
import { ACCREDITED_ESTABLISHMENTS_SPECIALIST } from '@/global/constants/reactQueryKeys'
import { addError } from '@/global/plugins/observability'
import {
  AccreditedEstablishmentsCode,
  Context
} from '@/global/plugins/observability/observability.constants'
import { ApiErrorResponse } from '@/global/api/types'
import { AxiosError } from 'axios'
import { toastApiError } from '@/global/utils/toastApiError/toastApiError'

export interface UseGetSpecialistDetailProps {
  referencedId?: string
}

export const useGetSpecialistDetail = ({
  referencedId
}: UseGetSpecialistDetailProps) => {
  const result = useQuery<
    GetSpecialistDetailResponse,
    AxiosError<ApiErrorResponse>
  >({
    queryKey: [...ACCREDITED_ESTABLISHMENTS_SPECIALIST, referencedId],
    queryFn: () => getSpecialistDetails(referencedId!),
    enabled: !!referencedId
  })

  const { error } = result

  useEffect(() => {
    if (error) {
      const data = {
        context: Context.ACCREDITED_ESTABLISHMENTS,
        code: AccreditedEstablishmentsCode.GET_SPECIALIST_DETAILS_ERROR,
        message: `Erro ao obter dados do especialista ${referencedId}`
      }
      addError({ error, data })

      toastApiError({ status: error.response?.status })
    }
  }, [error, referencedId])

  return result
}
